<template>
  <div>
    <table class="table table-xs table-hover">
      <thead>
      <tr>
        <th colspan="6" class="text-danger">ABONELİK BİLGİLERİ
          <el-tooltip class="item" effect="dark"
                      content="Gider işlenirken abone numarası ile otomatik borçlandırma sağlanır"
                      placement="top">
            <i class="el-icon-info text-primary cursor-pointer"></i>
          </el-tooltip>
          <button v-if="Yetki"
                  @click="this.Ekle"
                  class="el-button TableBtn el-button--success el-button--mini float-right">ABONELİK
            EKLE
          </button>
        </th>
      </tr>
      <tr>
        <th>Abonelik</th>
        <th>Kategori</th>
        <th>Abone No</th>
        <th>Fatura Günü</th>
        <th>Açıklama</th>
        <th v-if="Yetki" width="50"></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="Abonelik in Liste">
        <td>{{Abonelik.CariText}}</td>
        <td>{{Abonelik.KategoriText}}</td>
        <td>{{Abonelik.AboneNo}}</td>
        <td>{{Abonelik.Gun}}</td>
        <td>{{Abonelik.Aciklama}}</td>
        <td v-if="Yetki">
          <el-tooltip class="item" effect="dark" :content="Sayfa.DuzenleAdi"
                      placement="top-start">
            <a href="#" @click="Duzenle(Abonelik)" class="text-info mr-1"> <i
              class="feather-edit-2"></i></a>
          </el-tooltip>
          <el-tooltip class="item" effect="dark"
                      :content="Sayfa.SilAdi"
                      placement="top-start">
            <a href="#" @click="SilOnay(Abonelik.id)" class="text-danger"> <i
              class="el-icon-delete-solid"></i></a>
          </el-tooltip>


        </td>
      </tr>
      </tbody>
    </table>

    <el-form v-if="Form.Form" class="BilgiForm" :rules="FormHata" :model="Form"
             @submit.prevent.native="AbonelikKaydet"
             ref="Abonelik">
      <h2>{{Form.Baslik}} <a @click="Form=false" class="ModalKapat"><i class="el-icon-close"></i></a>
      </h2>

      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="Kategori" prop="Kategori_id">
            <el-cascader
              size="mini"
              :props="{ multiple: false}"
              :options="KategoriSelect"
              v-model="Form.Kategori_id"
              collapse-tags
              filterable></el-cascader>

          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Abonelik" prop="Cari_id">
            <el-select v-model="Form.Cari_id" size="mini" filterable>
              <el-option
                v-for="item in CariSelect"
                :key="item.id"
                :label="item.Unvan"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>


      </el-row>

      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="Abone No" prop="AboneNo">
            <el-input size="mini" type="input" v-model="Form.AboneNo">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="Ödeme Günü" prop="pGun">
            <el-input-number size="mini" v-model="Form.Gun" :min="1" :max="31"></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="Açıklama" prop="Aciklama">
            <el-input size="mini" type="textarea" v-model="Form.Aciklama">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <button type="button" @click="AbonelikKaydet"
              class="el-button mt-2 YeniBtn el-button--success el-button--mini btn-block">KAYDET
      </button>

    </el-form>
  </div>
</template>


<script>
  export default {
    props: {
      BinaBilgi: Object
    },
    data() {
      return {
        Sayfa: {
          ButtonAdi: this.$t('eGenel.10'),
          DuzenleAdi: this.$t('eGenel.10'),
          SilAdi: this.$t('eGenel.11'),
          Button: null,
          Adi: this.$t('eYonetim.20.0'),
          Menu: [],
          MenuDisplay: null,
        },
        Yetki: false,
        Liste: [],
        KategoriSelect: [],
        CariSelect: [],
        Form: {
          Baslik: 'Abonelik Ekle',
          id: null,
          Form: false,
          Cari_id: null,
          Bina_id: this.BinaBilgi.id,
          Kategori_id: null,
          Aciklama: null,
          AboneNo: null,
          Gun: null,
        },
        FormHata: {
          Cari_id: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          Kategori_id: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          AboneNo: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          Gun: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        }

      }
    },
    methods: {
      AbonelikKaydet() {
        this.$refs['Abonelik'].validate((valid) => {
            if (valid) {
              if (this.Form.id) {
                // EKLE
                this.$store.dispatch("Put", {
                  ...this.Form,
                  path: 'yonetim/bina/abonelik/' + this.Form.id
                })
                  .then(response => {
                    if (response.Durum == "OK") {
                      this.SayfaYukle();
                      this.$message.success(response.Mesaj);
                      this.Form = {
                        Baslik: 'Abonelik Ekle',
                        id: null,
                        Form: false,
                        Cari_id: null,
                        Bina_id: this.BinaBilgi.id,
                        Kategori_id: null,
                        Aciklama: null,
                        AboneNo: null,
                        Gun: null,
                      }
                    } else {
                      this.$message.error(response.Mesaj);
                      this.hata = response.Hata;
                    }
                  })
              } else {

                // EKLE
                this.$store.dispatch("Post", {
                  ...this.Form,
                  path: 'yonetim/bina/abonelik/' + this.BinaBilgi.id
                })
                  .then(response => {
                    if (response.Durum == "OK") {
                      this.SayfaYukle();
                      this.$message.success(response.Mesaj);
                      this.Form = {
                        Baslik: 'Abonelik Ekle',
                        id: null,
                        Form: false,
                        Cari_id: null,
                        Bina_id: this.BinaBilgi.id,
                        Kategori_id: null,
                        Aciklama: null,
                        AboneNo: null,
                        Gun: null,
                      }
                    } else {
                      this.$message.error(response.Mesaj);
                      this.hata = response.Hata;
                    }
                  })

              }
            }
          }
        );
      },
      SayfaYukle() {
        if (this.BinaBilgi.id) {
          this.$store.dispatch("Get", {path: 'yonetim/bina/abonelik/' + this.BinaBilgi.id})
            .then(response => {
              if (response.Durum === 'OK') {
                this.Liste = response.Liste
              } else {
                this.$message.error(response.Mesaj);
                this.hata = response.Hata;
              }
            });
          this.$store.dispatch("Get", {path: 'muhasebe/kategori'})
            .then(response => {
              if (response.Durum === 'OK') {
                this.KategoriSelect = response.Liste
              } else {
                this.$message.error(response.Mesaj);
                this.hata = response.Hata;
              }
            });
          this.$store.dispatch("Get", {path: 'muhasebe/cari'})
            .then(response => {
              if (response.Durum === 'OK') {
                this.CariSelect = response.Liste
              } else {
                this.$message.error(response.Mesaj);
                this.hata = response.Hata;
              }
            });
        }

        this.Yetki = this.$store.getters.Yetki.yonetim == 2 ? true : false;
      },
      Ekle() {
        this.Form = {
          Baslik: 'Abonelik Ekle',
          id: null,
          Form: true,
          Cari_id: null,
          Kategori_id: null,
          Aciklama: null,
          AboneNo: null,
          Gun: null,
          Bina_id: this.BinaBilgi.id
        }
      },
      Duzenle(Veri) {
        this.Form = {
          Baslik: 'Abonelik Düzenle',
          id: Veri.id,
          Form: true,
          Cari_id: Veri.Cari_id,
          Kategori_id: Veri.Kategori_id,
          Aciklama: Veri.Aciklama,
          AboneNo: Veri.AboneNo,
          Gun: Veri.Gun,
          Bina_id: this.BinaBilgi.id
        }
      },

      SilOnay(id) {
        this.$confirm(this.$t('eGenel.1'), this.$t('eGenel.7'), {
          confirmButtonText: this.$t('eGenel.2'),
          cancelButtonText: this.$t('eGenel.3'),
          type: 'warning'
        }).then(() => {
          this.Sil(id)
        }).catch(() => {
          this.$message.info(this.$t('eGenel.8'));
        });
      },
      Sil(id) {
        this.$store.dispatch("Delete", {...this.Form, path: 'yonetim/bina/abonelik/' + id})
          .then(response => {
            if (response.Durum == "OK") {
              this.ModalOlayi = false;
              this.$message.success(response.Mesaj);
              this.SayfaYukle();
            } else {
              this.$message.warning(response.Mesaj);
              this.hata = response.Hata;
            }
          })

      },

    },
    created() {
      this.SayfaYukle()
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Yonetim/bina/Comp/Abonelik.vue